import React, { useState,useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import video from '../../assets/images/video/ponbhoomimp4.mp4';
const VideoPlayer = ({ videoUrl, poster }) => {
    poster = 'https://www.gphomes.in/static/media/plotsBanner.e5a034c0c5fbed1c076d.jpg';
    videoUrl = video;
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className='video-player-section'>
      <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8 text-center">
                  <h2 className="display-6 fw-bold mb-3" data-aos="fade-up">
                    Step Inside Your <span className='underline-slide'>Dream Property</span>
                  </h2>
                </div>
              </div>
            </div>
    <div style={{ position: 'relative', width: '100%', maxWidth: '800px', margin: '0 auto' }} className='pt-5'>
      {isPlaying ? (
        <video
          src={videoUrl}
          controls
          autoPlay
          style={{ width: '100%', borderRadius: '10px' }}
        />
      ) : (
        <div style={{ position: 'relative', cursor: 'pointer' }} onClick={handlePlay}>
          <img
            src={poster}
            alt="Video thumbnail"
            style={{ width: '100%', borderRadius: '10px' }}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(0, 0, 0, 0.5)',
              borderRadius: '50%',
              padding: '20px',
            }}
          >
            <span style={{ fontSize: '2.5rem', color: 'white' }}>&#9658;</span>
          </div>
        </div>
      )}
    </div>
    </section>
  );
};

export default VideoPlayer;
